import SummaryResource from '@/resources/SummaryResource';

export default class Summary {
    constructor() {
        this.Resource = new SummaryResource()
    }

    async get (startDate, endDate, websiteId) {
        const summary = await this.Resource.get(startDate, endDate, websiteId)
        return summary.data
    }

    async getByWebsite (startDate, endDate, websiteId) {
        const summary = await this.Resource.get(startDate, endDate, websiteId)
        return summary.data
    }

    async getSummaryTransactions (startDate, endDate, websiteId) {
        const transactions = await this.Resource.getSummaryTransactions(startDate, endDate, websiteId)
        return transactions.data
    }
}
